import { tabletMax, mobileXXLargeMax, mobileXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import { GOLD } from '@propertypal/shared/src/styles/theme';
import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';
import { Text } from '../../typography';

export const PrimeHeaderContainer = styled.div`
  position: relative;
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.white};
  text-align: center;
  display: flex;
  position: relative;
  flex-direction: column;
`;

export const HeaderContainer = styled.div`
  max-width: 1240px;
  margin: 60px auto 70px auto;
  padding: 0 20px;
  color: ${({ theme }) => theme.textDark};

  h1 {
    font-family: ${platform.headingFont};
    font-size: 34px;
  }

  h2 {
    font-family: ${platform.headingFont};
    font-size: 40px;
    color: ${GOLD};
    margin-top: -10px;
  }

  p {
    font-size: 18px;
    margin-top: 20px;
  }

  @media screen and (${mobileXXLargeMax}) {
    h1 {
      font-size: 24px;
    }

    h2 {
      font-size: 26px;
    }

    p {
      font-size: 16px;
    }
  }

  @media screen and (${mobileXLargeMax}) {
    margin: 30px auto;
  }
`;

export const PromotionalOffer = styled.div`
  text-align: center;
  width: 100%;
  max-width: 540px;
  margin: 44px auto 0 auto;
  padding: 10px 45px;
  border-radius: 33px;
  background-color: ${({ theme }) => theme.prime.translucent.GOLD};

  @media (${tabletMax}) {
    padding: 15px;
  }
`;

export const PromotionalOfferText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
  gap: 10px;

  svg.mobile-icon {
    display: none !important;
  }

  svg {
    color: ${({ theme }) => theme.prime.GOLD};
  }

  @media (${tabletMax}) {
    font-size: 16px;
  }

  @media (${mobileXLargeMax}) {
    b span {
      display: none;
    }

    span span:not(:first-child) {
      display: block;
    }

    svg.mobile-icon {
      display: inline-block !important;
    }

    svg.desktop-icon {
      display: none !important;
    }

    svg {
      margin-right: 8px;
    }
  }
`;

export const PrimeHeaderSubHeading = styled(Text)`
  font-size: 20px;

  @media (${mobileXLargeMax}) {
    font-size: 16px;
  }
`;
